import React, {Component}  from 'react'
import EmailTemplatesSection from './emails/section.component.jsx'
import ProposalOptionsSection from './proposals/optionsSection.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import SalesToolsTabs from "../common/layout/tabs/salestools.component.jsx"
import DocumentTemplatesSection from "../template/section.component.jsx"
import SmsTemplatesSection from "./sms/SMSTemplateSection.tsx"

class BrandingSettings extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {}

    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    render() {
            return (
                <div>
                    <SalesToolsTabs/>
                    <DocumentTemplatesSection />
                    <EmailTemplatesSection />
                    <SmsTemplatesSection />
                    <ProposalOptionsSection />
                </div>
            );
    }

}

export default BrandingSettings


// WEBPACK FOOTER //
// ./src/settings/branding.component.jsx